import { createNativeStackNavigator } from '@react-navigation/native-stack'

import List from './list'

import { title } from 'src/utils'

const Stack = createNativeStackNavigator()

const MealSelect = () => (
  <Stack.Navigator
    initialRouteName="List"
    screenOptions={{ headerShown: false }}
  >
    <Stack.Screen
      name="List"
      component={List}
      options={{ title: title('Shopping List') }}
    />
  </Stack.Navigator>
)

export default MealSelect
